import React from 'react';
import Layout from '../components/Layout/Layout';

// Import all Peer Team Visit images
import ptv from '../images/preteamvisit.jpg';
import ptv1 from '../images/preteamvisit1.jpg';
import ptv2 from '../images/preteamvisit2.jpg';
import ptv3 from '../images/preteamvisit3.jpg';
import ptv4 from '../images/preteamvisit4.jpg';
import ptv5 from '../images/preteamvisit5.jpg';
import ptv6 from '../images/preteamvisit6.jpg';
import ptv7 from '../images/preteamvisit7.jpg';
import ptv8 from '../images/preteamvisit8.jpg';
import ptv9 from '../images/preteamvisit9.jpg';
import ptv10 from '../images/preteamvisit10.jpg';
import ptv11 from '../images/preteamvisit11.jpg';
import ptv12 from '../images/preteamvisit12.jpg';

const PeerTeamVisitPage = () => {
  const allVisitImages = [ptv, ptv1, ptv2, ptv3, ptv4, ptv5, ptv6, ptv7, ptv8, ptv9, ptv10, ptv11, ptv12];

  return (
    <Layout>
      <div id="peer-team-visit" className="page-container" style={{ backgroundColor: '#fff', minHeight: '100vh', padding: '40px 0' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
          
          <div style={{ 
            backgroundColor: '#fff', 
            padding: '40px', 
            borderRadius: '12px',
            boxShadow: '0 4px 25px rgba(0,0,0,0.1)',
            border: '1px solid #eee'
          }}>
            <h2 style={{ color: '#004488', borderBottom: '2px solid #add8e6', paddingBottom: '10px', marginBottom: '30px', fontSize: '2.2rem', fontWeight: 'bold', display: 'inline-block' }}>
              NAAC Visit Gallery
            </h2>

            <div style={{ 
              backgroundColor: '#333', 
              padding: '30px', 
              borderRadius: '8px',
              borderLeft: '5px solid #007bff',
              boxShadow: '0 4px 15px rgba(0,0,0,0.2)'
            }}>
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
                gap: '15px'
              }}>
                {allVisitImages.map((img, index) => (
                  <div key={index} style={{
                    borderRadius: '4px',
                    overflow: 'hidden',
                    boxShadow: '0 4px 10px rgba(0,0,0,0.4)',
                    height: '200px',
                    backgroundColor: '#1a1a1a'
                  }}>
                    <img 
                      src={img} 
                      alt={`NAAC Peer Team Visit ${index + 1}`} 
                      style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} 
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default PeerTeamVisitPage;
